import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions, SnackbarActions } from 'actionsets'
import StyleSheet, { AppStyles } from 'styles'
import { Link } from 'react-router-dom'
import { CenteredCard } from 'components'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import {eventKeyMatches, KEYS} from 'utils'

export class Forgot extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
  }

  componentDidMount(){
    this.actions.clearErrors()
  }

  setEmail = ({target: { value: email}}) => {
    this.setState({email})
  }

  submit = async () => {
    await this.actions.forgot(this.state)
    this.actions.snackbar.show("Request Sent")
  }

  renderError = () =>
    <Typography variant='body2' className={styles.error}>
      {this.props.error.title}
    </Typography>

  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.submit()}>
        <Typography variant='h6'>Having trouble signing in?</Typography>
        <Typography variant='body2'>Reset your password to continue</Typography>
        {this.props.error && <p className={styles.error}>{this.renderError()}</p>}
        <TextField
          autoFocus={window.innerWidth > 500}
          type="email"
          label='Enter your email address'
          onChange={this.setEmail}
          fullWidth
          margin="normal"
        />
      </CardContent>
      <CardActions className={styles.actions}>
        <Link className={[AppStyles.link, styles.signIn].join(' ')} to='/tokens/sign_in'>Sign In</Link>
        <Button className={styles.button} variant='contained' color="primary" onClick={this.submit}>Submit</Button>
      </CardActions>
    </CenteredCard>
}

const styles = StyleSheet({
  error: {
    color: '#EA5142'
  },
  button:{
    float: 'right',
    maxWidth: 200,
    margin: 0,
  },
  card: {
    padding: 15,
    paddingBottom: 50
  },
  signIn: {
    textDecoration: 'none',
    float: 'left'
  },
  actions: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
  }
})

export default connect(({tokens}) => tokens)(Forgot)